module.exports = __webpack_public_path__ + "media/images/maps/google_map-8a3ee9d95ee0f77595e2d7b7c7033c98.jpg";